import { createAction, props } from '@ngrx/store';

import type { CustomerMetadata } from '../models/customer-metadata.model'; // Import our model

// Action to initiate the lookup
export const lookupCustomer = createAction(
  '[CustomerSettings API] Lookup Customer',
  props<{ domain: string }>()
);

// Action on successful lookup
export const lookupCustomerSuccess = createAction(
  '[CustomerSettings API] Lookup Customer Success',
  props<{ customerMetadata: CustomerMetadata }>() // Use CustomerMetadata
);

// Action on failed lookup
export const lookupCustomerFailure = createAction(
  '[CustomerSettings API] Lookup Customer Failure',
  props<{ error: string }>() // Changed payload type to string
);
